import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TextInputDataComponent } from '../../../components/text-input/text-input.component';
import { SelectComponent } from '../../../components/select/select.component';
import { HandleBookingService } from '../../../services/handle-booking.service';
import { RadioBtnComponent } from '../../../components/radio-btn/radio-btn.component';
import { ParkingRepo } from '../../../repo/parking.repo';
import { TranslocoModule, TranslocoService } from '@jsverse/transloco';
import { EmailInputFieldComponent } from '../../../components/email-input-field/email-input-field.component';
import { PhoneNumberInputComponent } from '../../../components/phone-number-input/phone-number-input.component';
import { CommonModule, UpperCasePipe } from '@angular/common';
import { FormService } from '../../../organizations/features/booking/components/form/service';
import { MatDialog } from '@angular/material/dialog';
import { BookingSummaryCardComponent } from '../../../components/booking-summary-card/booking-summary-card.component';
import { BookingConfigService } from '../../../services/booking-config.service';
import { FormGroup } from '@angular/forms';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatListModule } from '@angular/material/list';
import { MatIconModule } from '@angular/material/icon';
import { BackOfficeService } from '../../../../services/backoffice.service';
import { TopNavbarComponent } from '../../../../parkifly-bookings/organizations/components/top-navbar/top-navbar.component';
import { SharedModule } from '../../../../shared/shared.module';
import { environment } from '../../../../../environments/environment';

@Component({
  selector: 'app-my-order-details',
  imports: [
    RouterLink,
    TextInputDataComponent,
    SelectComponent,
    RadioBtnComponent,
    TranslocoModule,
    EmailInputFieldComponent,
    PhoneNumberInputComponent,
    CommonModule,
    BookingSummaryCardComponent,
    MatProgressBarModule,
    MatListModule,
    MatIconModule,
    UpperCasePipe,
    TopNavbarComponent,
    SharedModule
  ],
  providers: [HandleBookingService],
  templateUrl: './my-order-details.component.html',
  styleUrl: './my-order-details.component.css',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.Eager,
  host: {
    'style': 'font-family: Inter, sans-serif;'
  }
})

export class MyOrderDetailsComponent {

  handleBookingStatus: 'error' | 'updated' | '' = '';
  handleBookingGroup: any;
  // email: string | null = "";
  // bookingNumber: string | null = "";
  arrivalParkingOptions = [
    { value: '', viewValue: '' },
  ];
  parkingFrom: any;
  site: string = ""
  booking: any = null;
  checkInBagage: any = []
  additionalServices: any;
  orderId: any = null;
  parkType: string = '';
  freeShuttles: boolean = false;
  bookingDetails: any = {
    order: null,
    parking: null,
    shuttles: [],
    additionalServices: []
  };
  form !: FormService;
  parkingType!: string;
  details !: FormGroup;
  parkingGroup: any;
  departureHotel: any;
  arrivalHotel: any;
  bookingLoaded: boolean = false;
  activeLang: string = 'sv';
  isLoading: boolean = false;
  parkingNames: any = {
    "677844ae-bb01-4265-bfde-32264410ed09": 'P_49', //p2 inomus
    "453f945a-ee11-4d75-8265-b16f00e5f04b": 'P_41', //p1 storbil
    "f9e5d6c3-4419-4c61-a290-b16f00e5e500": 'P_40', //el bil
    "8c98315a-b2ad-4e70-86f9-5d54992fed26": 'P_39', //Långtidsparkering,
    "697844ae-bb01-4265-bfde-32264410ed09": 'P_67', //VIP
    "c797769e-66bf-4283-96c5-b16f00e5e126": 'P_1',
    "eacc8615-81a4-4013-a7e5-b16f00e5e270": 'P_6',
    "1a8879f4-a294-455b-97eb-b16f00e5e30a": 'P_12',
    "5d2c7728-6944-45a6-a64e-b16f00e5e3b3": 'P_18',
    "8d922482-7855-47dc-953b-b16f00e5e45a": 'P_24'
  }
  @Input() bookingInfo: any = null;
  baseUrl: string = '';

  constructor(
    private router: Router,
    private handleBookingService: HandleBookingService,
    private parkingRepo: ParkingRepo,
    public dialog: MatDialog,
    private translocoService: TranslocoService,
    private bookingConfigService: BookingConfigService,
    private _formService: FormService,
    public backofficeService: BackOfficeService,
  ) {
    const config = this.bookingConfigService.getConfig();
    this.site = config.site;
  }

  ngOnInit() {
    this.getOrderDetails();
    this.activeLang = this.translocoService.getActiveLang();
    this.translocoService.langChanges$.subscribe((lang) => {
      this.activeLang = lang;
    });
    this.translocoService.selectTranslate('PARKIFLY.PLACEHOLDER.1_HOUR_BEFORE')
      .subscribe(value => {
        this.checkInBagage = [
          { value: '1', viewValue: this.translocoService.translate("PARKIFLYFORM.YES") },
          { value: '0', viewValue: this.translocoService.translate("PARKIFLY.SUMMARY.ONLY_CARRYON_LUGGAGE_OPTION") },
        ]
      });
    const identityUrl = JSON.parse(environment.IDENTITY);
    this.baseUrl = identityUrl === '/' ? `${window.location.origin}/` : identityUrl;
  }

  getOrderDetails() {
    const bookingDetails = this.bookingInfo;
    this.site = bookingDetails.organizationName?.toLowerCase();
    if (this.site == "flygets.se" || this.site == "ving" || this.site == "tui" || this.site == "nazar") {
      this.site = "flygets";
    }

    this.bookingConfigService.setOrganization(this.site);
    this.handleBookingService.initForm(this.site);
    this.handleBookingGroup = this.handleBookingService.getForm().get('details');
    this._formService.initForm(this.site);

    //pdf details
    this.parkingType = this._formService.selectedParking;
    this.form = this._formService;
    this.details = this.form.getForm().get('details');
    this.parkingGroup = this.form.getForm().get('parkingGroup');
    this.departureHotel = this.form.departureHotel || this.form.getForm().get('hotels')?.controls?.departureHotel?.value;
    this.arrivalHotel = this.form.arrivalHotel || this.form.getForm().get('hotels')?.controls?.arrivalHotel?.value;

    // if (bookingDetails.orderStatus == "Cancelled") {
    //   this.router.navigate(['/parkifly-new/handle-booking']);
    // }
    this.orderId = bookingDetails.orderId;
    this.booking = bookingDetails;

    if (this.booking != null) {
      setTimeout(() => {
        this.bookingLoaded = true;
      }, 1000);
    }

    this.handleBookingService.getForm().get('details').controls['cellular'].setValue(bookingDetails.cellular ?? '');
    this.handleBookingService.getForm().get('details').controls['regNr'].setValue(bookingDetails.carRegNumber ?? '');
    this.handleBookingService.getForm().get('details').controls['email'].setValue(bookingDetails.email ?? '');
    this.handleBookingService.getForm().get('details').controls['email'].disable();
    if (this.site === 'skavsta') {
      this.handleBookingService.getForm().get('details').controls['firstname'].setValue(bookingDetails.firstName ?? '');
      this.handleBookingService.getForm().get('details').controls['firstname'].disable();
      this.handleBookingService.getForm().get('details').controls['lastname'].setValue(bookingDetails.lastName ?? '');
      this.handleBookingService.getForm().get('details').controls['lastname'].disable();
      this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
      this.booking.parkingShuttleFrom = bookingDetails.parkingFrom;
      this.booking.parkingShuttleTo = bookingDetails.parkingTo;
      this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
    }
    if (this.site === 'flygets') {
      this.handleBookingService.getForm().get('details').controls['comment'].setValue(bookingDetails.comment ?? '');
      this.handleBookingService.getForm().get('details').controls['contact'].setValue("false");
      this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
      this.parkingFrom = bookingDetails.parkingFrom;
      this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
      this.parkingFrom = new Date(this.parkingFrom);
      var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
      var currentParkingTime = (
        parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
        (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
        );
      this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(currentParkingTime);

      // const additionalServicesArray = bookingDetails?.additionalServices?.length > 0
      //   ? bookingDetails.additionalServices.filter((e: any) => e.status != 'Cancelled')
      //   : [];
      const additionalServicesArray = bookingDetails?.additionalServices?.length > 0
        ? bookingDetails.additionalServices : [];

      if (additionalServicesArray.length > 0) {
        additionalServicesArray.forEach(function (element: any, index: any) {
          if (typeof element.name === 'string') {
            element.name = JSON.parse(element.name);
          }
          if (typeof element.description === 'string') {
            element.description = JSON.parse(element.description);
          }
          if (element.amount && element.vatAmount) {
            element.amount = element.amount + element.vatAmount;
          }
        });
      }
      this.bookingDetails.additionalServices = additionalServicesArray;
      this.bookingDetails.additionalProducts = bookingDetails.additionalProducts;
    }
    if (this.site === 'mdpark') {
      this.handleBookingService.getForm().get('details').controls['comment'].setValue(bookingDetails.comment ?? '');
      this.handleBookingService.getForm().get('details').controls['contact'].setValue("false");
      this.handleBookingService.getForm().get('details').controls['persons'].setValue(bookingDetails.passengers.toString());
      this.parkingFrom = bookingDetails.parkingFrom;
      this.arrivalParkingOptions = this.parkingRepo.createParkingStartTimeOptions(this.parkingFrom);
      this.parkingFrom = new Date(this.parkingFrom);
      var parkingShuttleFrom = new Date(bookingDetails.parkingShuttleFrom);
      var currentParkingTime = (
        parkingShuttleFrom.getHours().toString().length <= 1 ? '0' + parkingShuttleFrom.getHours() : parkingShuttleFrom.getHours()) + ':' +
        (parkingShuttleFrom.getMinutes().toString().length <= 1 ? '0' + parkingShuttleFrom.getMinutes() : parkingShuttleFrom.getMinutes()
        );
      this.handleBookingService.getForm().get('details').controls['arrivalTimeAtParking'].setValue(currentParkingTime);
    }
    this.isLoading = false;
  }

  get bookingDuration(): number {
    if (!this.booking?.parkingFrom || !this.booking?.parkingTo) return 0;
    const from = new Date(this.booking.parkingFrom);
    const to = new Date(this.booking.parkingTo);
    return Math.ceil((to.getTime() - from.getTime()) / (1000 * 60 * 60 * 24));
  }

  goToBookingOverview() {
    this.router.navigate(['parkifly/booking-overview', { email: this.bookingInfo.email, booking_number: this.bookingInfo.orderNumber }]);
  }

  goToPayment() {
    if (this.booking?.orderStatus?.toLowerCase() === 'checkout' || this.booking?.orderStatus?.toLowerCase() ===
      'checkoutadditional' || this.booking?.orderStatus?.toLowerCase() === 'driveup') {
      this.router.navigate(['parkifly', this.site, 'checkout', 'payment', this.orderId]);
    }
  }

}
